export default "__VITE_ASSET__ywWRymQD__"